import React from 'react';
import { FormGroup, Input, Label, FormFeedback } from 'reactstrap';
import ErrorList from '../ErrorList';

type OffsiteOptionProps = {
    enabled: boolean;
    onChange: (enabled: boolean) => unknown;
    errors?: string[];
    monthlyCost?: number;
    disabled?: boolean;
};

export default class OffsiteOptions extends React.Component<OffsiteOptionProps> {
    render() {
        const { errors, onChange, enabled, monthlyCost, disabled } = this.props;
        const costText = monthlyCost ? ` (+$${monthlyCost.toFixed(2)} per month)` : '';
        const requirementText = disabled ? ' (requires on-site backups)' : '';
        return (
            <FormGroup check>
                <Input
                    id="offsiteBackupOptionCheck"
                    invalid={!!errors}
                    type="checkbox"
                    checked={enabled || false}
                    disabled={disabled}
                    onChange={(e) => onChange(e.target.checked)}
                />
                <Label check for="offsiteBackupOptionCheck">
                    Offsite Backups{requirementText}
                    {costText}
                </Label>
                <FormFeedback>
                    <ErrorList errors={errors} />
                </FormFeedback>
            </FormGroup>
        );
    }
}
